(function () {
  Flint.file('mframework/views/pic.js', function (require) {
    Flint.view('Pic', function (view, on, $) {
      var pro = initPro(view, {
        picKey: atom(),
        style: M.mergeAtom({}),

        enhance: M.defaultAtom(true),
        faces: M.defaultAtom(false),
        fit: M.defaultAtom('crop'),
        entropy: M.defaultAtom(false),

        zoomable: M.defaultAtom(false)
      });

      var zoomedIn = atom(false);

      var imgixUrl = derivation(function () {
        var params = {
          auto: pro.enhance.get() ? 'enhance' : null,
          crop: pro.faces.get() ? 'faces' : pro.entropy.get() ? 'entropy' : null,
          fit: pro.fit.get(),
          w: pro.style.get().get('width') || pro.style.get().get('maxWidth'),
          h: pro.style.get().get('height') || pro.style.get().get('maxHeight')
        };
        var paramString = M.util.objToParamString(params);
        return '' + M.config.imgixPrefix + pro.picKey.get() + '?' + paramString;
      });view.render(function () {
        return view.el(
          ['pic', 1],
          {
            style: IMap({
              alignItems: 'center',
              justifyContent: 'center',
              cursor: pro.zoomable.get() ? 'zoom-in' : null
            }).merge(pro.style.get()).toJS(),
            onClick: function (e) {
              if (pro.zoomable.get()) {
                zoomedIn.set(true);
                if (zoomedIn.get() && view.props.onZoomIn) {
                  view.props.onZoomIn({});
                } else if (!zoomedIn.get() && view.props.onZoomOut) {
                  view.props.onZoomOut({});
                }
              }
              view.props.onClick && view.props.onClick(e);
            }
          },
          view.el(['img', 1], {
            src: imgixUrl.get(),
            style: pro.style.get().merge({
              width: null,
              height: null
            }).toJS()
          }),
          Flint.iff(zoomedIn.get()) && view.el(['Lightbox', 1], { if: zoomedIn.get(),
            onClose: function () {
              return zoomedIn.set(false);
            },
            picKeys: [pro.picKey.get()]
          })
        );
      });
    });
  })
})();
//# sourceMappingURL=pic.js.map
